import styles from "@/styles/components/gradientTitle.module.scss";

interface Props {
    text: any;
    fontSize?: string;
    fontWeight?: string;
    centeredText?: boolean;
}

export default function GradientTitle({text, fontSize = "40px", fontWeight = "600", centeredText = false}: Props){

    return(
        <div 
            className = {styles.rootDiv}
            style = {{
                textAlign: (centeredText ? "center" : "left"),
            }}>
            <div 
                className = {styles.text}
                dangerouslySetInnerHTML = {{__html: text}}
                style = {{
                    fontSize: fontSize,
                    fontWeight: fontWeight,
                }} />
        </div>
    )
}